import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { marker as l10n } from '@biesbjerg/ngx-translate-extract-marker';
import { of } from 'rxjs';
import { IShellDisplay, SHELL_DISPLAY } from '@shared/metadata/IShellDisplay';
import {
  NavMenuItem,
  NavMenuItemType,
  NavMenuSection,
  NAV_MENU_ITEM,
} from '@shared/metadata/INavMenuItem';
import {
  IToolbarButton,
  TOOLBAR_BUTTON,
} from '@shared/metadata/IToolbarButton';
import { StreamlineIconsModule } from '@shared/icons/streamline-icons.module';

const toolBarButton: IToolbarButton = {
  svgIcon: 'streamline:house-1',
  titleKey: l10n('HOME.TOOLBAR_BUTTON'),
  link: '/pages/home',
  order: 100,
};

const shellDisplay: IShellDisplay = {
  route: '/pages/home',
  navTitleKey: l10n('HOME.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:house-1',
  fullScreen: true,
  hideNavBar$: of(true),
};

const navMenuItem: NavMenuItem = {
  type: NavMenuItemType.SingleItem,
  route: '/pages/home',
  section: NavMenuSection.Top,
  titleKey: l10n('HOME.NAV_TITLE'),
  svgIcon: 'streamline:house-1',
  order: 100,
};

@NgModule({
  declarations: [],
  imports: [MatIconModule, StreamlineIconsModule],
  providers: [
    { provide: TOOLBAR_BUTTON, useValue: toolBarButton, multi: true },
    { provide: SHELL_DISPLAY, useValue: shellDisplay, multi: true },
    { provide: NAV_MENU_ITEM, useValue: navMenuItem, multi: true },
  ],
})
export class HomeMetadataModule {}
